import WorkOrderList from "@/components/WorkOrders/WorkOrderList.vue";
import WorkOrderEdit from "@/components/WorkOrders/WorkOrderEdit.vue";
import WorkOrderHeader from "@/components/WorkOrders/WorkOrderHeader.vue";

export default [
    {
        path: "/workorders",
        alias: ["/workorder"],
        name: "WorkOrders",
        redirect: "/workorder/list",
        components: {
            page: WorkOrderList,
            header: WorkOrderHeader
        },
        meta: {
            title: "Work Orders",
            requiresAuth: true
        },
        children: [
            {
                path: "/workorder/list",
                name: "WorkOrder List",
                components: {
                    // Empty - uses parent page component
                }
            },
            {
                path: "/workorder/edit/:id",
                name: "WorkOrder Edit",
                components: {
                    modal: WorkOrderEdit
                }
            }
        ]
    }
];
